import {
    CalculatorOutlined,
    CloudUploadOutlined,
    ImportOutlined,
    SendOutlined
} from '@ant-design/icons';
import { Button, Card, DatePicker, Form, Input, Layout, List, message, Modal, Pagination, Progress, Select, Space, Table, theme, Typography, Upload } from 'antd';
import axios from 'axios';
import ExcelJS from "exceljs";
import * as FileSaver from "file-saver";
import { saveAs } from "file-saver";
import { collection, deleteDoc, doc, getDocs, query, serverTimestamp, updateDoc, where, writeBatch } from "firebase/firestore";
import JSZip from "jszip";
import { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import * as xlsx from 'xlsx';
import apis from '../../apis';

import {
    ageCategories,
    brassAgeCategoriesSolo,
    competitionList,
    ensembleAgeCategories,
    guitarAgeCategoriesSolo,
    guzhengAgeCategoriesEnsemble,
    guzhengAgeCategoriesSolo,
    harpAgeCategoriesSolo,
    percussionAgeCategoriesSolo,
    stringAgeCategoriesSolo,
    vocalAgeCategoriesSolo,
    woodwinAgeCategoriesSolo
} from '../../constant/RegisterPageConst';
import { getRegistrants2025Columns } from '../../constant/RegistrantsColumn';
import { db } from '../../firebase';
import usePaginatedRegistrants from '../../hooks/useFetchRegistrantsData';
import { calculateAward, parseDateString } from '../../utils/Utils';
// ...other imports
const { Content } = Layout;

const RegistrantDashboard = () => {
    const competitionCategoryOptions = Object.values(competitionList).map(cat => ({ value: cat, label: cat }));

    const ageCategoryOptions = Object.keys(ageCategories).map(key => ({ value: key, label: ageCategories[key] }));

    const performanceCategoryOptions = [
        { value: 'Solo', label: 'Solo' },
        { value: 'Ensemble', label: 'Ensemble' },
    ];
    const pageSize = 10

    const { token: { colorBgContainer, borderRadiusLG }, } = theme.useToken();

    const [isUploading, setIsUploading] = useState(false);

    // --- NEW STATE FOR THE EDIT MODAL ---
    const [editFormState, setEditFormState] = useState({
        firstName: '',
        lastName: '',
        youtubeLink: '',
        ageCategory: '',
        email: "",
    });
    const [isEditModalVisible, setIsEditModalVisible] = useState(false);
    const [editingRecord, setEditingRecord] = useState(null);
    const [isSaving, setIsSaving] = useState(false);
    const [isDownloadingAll, setIsDownloadingAll] = useState(false);
    const [deletingId, setDeletingId] = useState(null);
    const [ageFilter, setAgeFilter] = useState(null); // null means "All"
    const [performanceFilter, setPerformanceFilter] = useState(null);
    // 1. Add state to hold the current search term
    const [searchTerm, setSearchTerm] = useState('');
    const [searchTeacherName, setSearchTeacherName] = useState('');
    const [competitionFilter, setCompetitionFilter] = useState(null);
    const [exportCategory, setExportCategory] = useState(null);
    const [emailDateRange, setEmailDateRange] = useState(null);
    const [eventIdFilter, setEventIdFilter] = useState(null);
    const [isMigratingEventId, setIsMigratingEventId] = useState(false);
    const [isSendingEmails, setIsSendingEmails] = useState(false);

    const [isRescheduleModalVisible, setIsRescheduleModalVisible] = useState(false);
    const [rescheduleSearchTerm, setRescheduleSearchTerm] = useState('');
    const [rescheduleSelectedRowKeys, setRescheduleSelectedRowKeys] = useState([]);
    const [isSendingRescheduleEmails, setIsSendingRescheduleEmails] = useState(false);

    // --- State for Gala Concert Update Email ---
    const [galaUpdateCategory, setGalaUpdateCategory] = useState(null);
    const [isSendingGalaUpdate, setIsSendingGalaUpdate] = useState(false);
    const [isGalaUpdateModalVisible, setIsGalaUpdateModalVisible] = useState(false);
    const [galaUpdateRecipients, setGalaUpdateRecipients] = useState([]);
    const [galaUpdateSelectedRowKeys, setGalaUpdateSelectedRowKeys] = useState([]);
    const [galaUpdateSearchTerm, setGalaUpdateSearchTerm] = useState('');


    const [isStatsModalVisible, setIsStatsModalVisible] = useState(false);
    const [teacherStats, setTeacherStats] = useState([]);

    // --- State: Upload Certificate/Comment Sheet ---
    const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
    const [uploadingRecord, setUploadingRecord] = useState(null);
    const [uploadFileList, setUploadFileList] = useState([]);
    const [isUploadingCert, setIsUploadingCert] = useState(false);

    const [scoresMap, setScoresMap] = useState({});
    const [isScoreSyncing, setIsScoreSyncing] = useState(false);

    // --- State for CSV Score Import ---
    const [isImportScoreModalOpen, setIsImportScoreModalOpen] = useState(false);
    const [importScoreResults, setImportScoreResults] = useState({ matched: [], unmatched: [] });
    const [isImportingScores, setIsImportingScores] = useState(false);
    const importScoreFileRef = useRef(null);

    // 2. Pass the searchTerm to your updated hook
    const {
        allData,
        registrantDatas,
        loading,
        error,
        page,
        setPage,
        totalPages,
        totalDocs,
        fetchData: fetchUserData,
    } = usePaginatedRegistrants(pageSize, "Registrants2025", "createdAt", searchTerm, searchTeacherName, ageFilter,
        performanceFilter, competitionFilter, eventIdFilter);

    // --- State for the new update process ---
    const [isUpdating, setIsUpdating] = useState(false);
    const [progress, setProgress] = useState(0);
    const [updateMessage, setUpdateMessage] = useState('');

    const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
    const [videoUrl, setVideoUrl] = useState(null);

    const handleSendEmailAnnouncement = async () => {
        if (!allData || allData.length === 0) {
            toast.error("No data available to send emails.");
            return;
        }

        let dataToProcess = allData;

        // 1. Filter by date if a range is selected
        if (emailDateRange && emailDateRange.length === 2) {
            const startDate = emailDateRange[0].startOf('day').toDate();
            const endDate = emailDateRange[1].endOf('day').toDate();

            dataToProcess = allData.filter(registrant => {
                const createdAt = registrant.createdAt ? new Date(registrant.createdAt.seconds * 1000) : null;
                if (!createdAt) return false;
                return createdAt >= startDate && createdAt <= endDate;
            });

            if (dataToProcess.length === 0) {
                toast.warn("No registrants found within the selected date range.");
                return;
            }
        } else {
            // Confirm if sending to ALL
            const confirmed = window.confirm("You have not selected a date range. This will send emails to ALL registrants. Are you sure?");
            if (!confirmed) return;
        }

        // 2. Map data for backend
        const mappedData = [];
        dataToProcess.forEach(registrant => {
            const isEnsemble = (registrant.PerformanceCategory || '').trim().toLowerCase() === 'ensemble';
            const award = registrant.finalAward || 'FAIL';
            const performers = registrant.performers || [];

            if (performers.length === 0) return;

            // Common name for all recipients in this registration
            let combinedName;
            if (performers.length > 1) {
                combinedName = performers
                    .map(p => (p.fullName || `${p.firstName || ''} ${p.lastName || ''}`).trim())
                    .join(' & ');
            } else {
                combinedName = performers[0].fullName || `${performers[0].firstName} ${performers[0].lastName}`;
            }

            if (isEnsemble) {
                // Send to ALL performers in the ensemble
                performers.forEach(performer => {
                    mappedData.push({
                        name: combinedName,
                        email: performer.email,
                        award: award
                    });
                });
            } else {
                // Solo
                mappedData.push({
                    name: combinedName,
                    email: performers[0].email,
                    award: award
                });
            }
        });

        // Remove any entries without email or name just to be safe
        const validData = mappedData.filter(item => item.email && item.name);

        if (validData.length === 0) {
            toast.warn("No valid emails found to send to.");
            return;
        }

        console.log(validData);
        setIsSendingEmails(true);
        try {
            toast.info(`Sending emails to ${validData.length} registrants...`);
            await apis.email.sendEmailAnnouncementJson({ registrants: validData });
            toast.success(`Successfully enqueued emails to ${validData.length} registrants!`);
        } catch (error) {
            console.error(error);
            toast.error(`Failed to send emails: ${error.message || 'Unknown error'}`);
        } finally {
            setIsSendingEmails(false);
        }
    };

    const handleSendRescheduleEmail = async () => {
        if (rescheduleSelectedRowKeys.length === 0) {
            toast.warn("Please select at least one registrant to send the email.");
            return;
        }

        // Map selected keys back to full registrant records
        const selectedRegistrants = (allData || []).filter(r => rescheduleSelectedRowKeys.includes(r.id));

        const payload = [];
        selectedRegistrants.forEach(r => {
            const performers = r.performers || [];
            if (performers.length === 0) {
                if (r.email && r.name) {
                    payload.push({ name: r.name, email: r.email });
                }
                return;
            }

            let combinedName;
            if (performers.length > 1) {
                combinedName = performers
                    .map(p => (p.fullName || `${p.firstName || ''} ${p.lastName || ''}`).trim())
                    .join(' & ');
            } else {
                combinedName = performers[0].fullName || `${performers[0].firstName} ${performers[0].lastName}`;
            }

            const isEnsemble = (r.PerformanceCategory || '').trim().toLowerCase() === 'ensemble';
            if (isEnsemble) {
                performers.forEach(p => {
                    if (p.email) {
                        payload.push({ name: combinedName, email: p.email });
                    }
                });
            } else {
                if (performers[0].email) {
                    payload.push({ name: combinedName, email: performers[0].email });
                }
            }
        });

        if (payload.length === 0) {
            toast.warn("No valid email addresses found for the selected registrants.");
            return;
        }

        setIsSendingRescheduleEmails(true);
        try {
            toast.info(`Sending reschedule emails to ${payload.length} registrant(s)...`);
            await apis.email.sendEmailStageReschedule({ registrants: payload });
            toast.success(`Successfully sent reschedule emails to ${payload.length} registrant(s)!`);
            setIsRescheduleModalVisible(false);
            setRescheduleSelectedRowKeys([]);
            setRescheduleSearchTerm('');
        } catch (error) {
            console.error(error);
            toast.error(`Failed to send emails: ${error.message || 'Unknown error'}`);
        } finally {
            setIsSendingRescheduleEmails(false);
        }
    };

    const handleSendGalaConcertUpdateEmail = async () => {
        if (!galaUpdateCategory) {
            toast.warn("Please select a category first.");
            return;
        }

        if (!allData || allData.length === 0) {
            toast.error("No data available to send emails.");
            return;
        }

        // 1. Filter by category AND award is 'GOLD', 'SILVER', or 'DIAMOND' or 'SAPPHIRE'
        const winnersInCategory = allData.filter(registrant => {
            const isTargetCategory = registrant.competitionCategory === galaUpdateCategory;
            const allowedAwards = ['GOLD', 'SILVER', 'DIAMOND', 'SAPPHIRE'];
            const currentAward = (registrant.finalAward || '').toUpperCase();
            const isWinner = allowedAwards.includes(currentAward);
            return isTargetCategory && isWinner;
        });

        if (winnersInCategory.length === 0) {
            toast.warn(`No winners found for category: ${galaUpdateCategory}`);
            return;
        }

        // 2. Map data for backend
        const mappedData = [];
        winnersInCategory.forEach(registrant => {
            const isEnsemble = (registrant.PerformanceCategory || '').trim().toLowerCase() === 'ensemble';
            const performers = registrant.performers || [];

            if (performers.length === 0) {
                if (registrant.email && registrant.name) {
                    mappedData.push({ name: registrant.name, email: registrant.email });
                }
                return;
            }

            let combinedName;
            if (performers.length > 1) {
                combinedName = performers
                    .map(p => (p.fullName || `${p.firstName || ''} ${p.lastName || ''}`).trim())
                    .join(' & ');
            } else {
                combinedName = performers[0].fullName || `${performers[0].firstName} ${performers[0].lastName}`;
            }

            if (isEnsemble) {
                performers.forEach(p => {
                    if (p.email) {
                        mappedData.push({ name: combinedName, email: p.email });
                    }
                });
            } else {
                if (performers[0].email) {
                    mappedData.push({ name: combinedName, email: performers[0].email });
                }
            }
        });

        if (mappedData.length === 0) {
            toast.warn("No valid emails found to send to.");
            return;
        }

        // Add index as key for the selection table
        const recipientsWithId = mappedData.map((item, index) => ({
            ...item,
            id: index
        }));

        setGalaUpdateRecipients(recipientsWithId);
        setGalaUpdateSelectedRowKeys(recipientsWithId.map(r => r.id)); // Select all by default
        setIsGalaUpdateModalVisible(true);
    };

    const handleGalaUpdateConfirmSend = async () => {
        const selectedRecipients = galaUpdateRecipients.filter(r => galaUpdateSelectedRowKeys.includes(r.id));

        if (selectedRecipients.length === 0) {
            toast.warn("Please select at least one recipient.");
            return;
        }

        setIsSendingGalaUpdate(true);
        try {
            toast.info(`Sending Gala Update emails to ${selectedRecipients.length} recipients...`);
            await apis.email.sendEmailGalaConcertUpdate({ registrants: selectedRecipients });
            toast.success(`Successfully sent Gala Update emails to ${selectedRecipients.length} recipients!`);
            setIsGalaUpdateModalVisible(false);
            setGalaUpdateCategory(null);
        } catch (error) {
            console.error(error);
            toast.error(`Failed to send emails: ${error.message || 'Unknown error'}`);
        } finally {
            setIsSendingGalaUpdate(false);
        }
    };

    const handleSendTestEmail = async (type) => {
        const testEmail = "renaldolouis555@gmail.com";
        const testName = "Renaldo Louis (Test)";
        const payload = {
            registrants: [{ name: testName, email: testEmail }, { name: "Jefriandy (Test)", email: "jefriandy2@gmail.com" }]
        };

        try {
            toast.info(`Sending test ${type} email...`);

            if (type === 'announcement') {
                await apis.email.sendEmailAnnouncement(payload);
            } else if (type === 'reschedule') {
                await apis.email.sendEmailStageReschedule(payload);
            } else if (type === 'gala_update') {
                await apis.email.sendEmailGalaConcertUpdate(payload);
            }

            toast.success(`Successfully sent test ${type} email to ${testEmail}!`);
        } catch (error) {
            console.error(error);
            toast.error(`Failed to send test email: ${error.message || 'Unknown error'}`);
        }
    };

    const getAgeCategoryLabel = (ageCategoryKey, competitionCategory, performanceCategory) => {
        if (!ageCategoryKey) return '';

        // Create a combined map of all age categories
        const allAgeCategories = {
            // Piano
            ...ageCategories,
            ...ensembleAgeCategories,

            // Strings
            ...stringAgeCategoriesSolo,

            // Vocal/Choir
            ...vocalAgeCategoriesSolo,

            // Woodwinds
            ...woodwinAgeCategoriesSolo,

            // Percussion
            ...percussionAgeCategoriesSolo,

            // Guitar
            ...guitarAgeCategoriesSolo,

            // Brass
            ...brassAgeCategoriesSolo,

            // Harp
            ...harpAgeCategoriesSolo,

            // Guzheng
            ...guzhengAgeCategoriesSolo,
            ...guzhengAgeCategoriesEnsemble,
        };

        // Return the full description or the key if not found
        return allAgeCategories[ageCategoryKey] || ageCategoryKey;
    };

    const handlePageChange = (pagination, filters, sorter, extra) => {
        setPage(pagination);
    };

    const stripS3Prefix = (uri) => {
        const parts = uri.split('/');
        // Remove 's3:', '', 'bucket-name'
        return parts.slice(3).join('/');
    };

    const handleCompetitionFilterChange = (value) => {
        setPage(1); // Reset to page 1 when filter changes
        setCompetitionFilter(value);
    };

    async function createAndDownloadZip(pdfBlobs) {
        console.log("pdfBlobs", pdfBlobs)
        const zip = new JSZip();

        for (let i = 0; i < pdfBlobs.length; i++) {
            const blob = pdfBlobs[i];
            let currentData = registrantDatas[i]
            zip.file(`${currentData.name}-${i}.pdf`, blob);
        }

        const zipBlob = await zip.generateAsync({ type: "blob" });
        saveAs(zipBlob, "registrant.zip");
    }

    const handleAgeFilterChange = (value) => {
        setPage(1); // Reset to page 1 when filter changes
        setAgeFilter(value);
    };

    const handlePerformanceFilterChange = (value) => {
        setPage(1); // Reset to page 1 when filter changes
        setPerformanceFilter(value);
    };


    // --- NEW FUNCTION to calculate and show teacher stats ---
    const handleShowStatsModal = () => {
        if (!allData || allData.length === 0) {
            toast.info("No data to generate statistics.");
            return;
        }

        // Helper to get a consistent teacher name from a record
        const getTeacherName = (registrant) => {
            const name = registrant.teacherName || (registrant.userType === 'Teacher' ? registrant.name : null);
            return name ? name.trim() : null;
        };

        // Use reduce to group registrations by teacher and count their performance types
        const stats = allData.reduce((acc, registrant) => {
            const teacher = getTeacherName(registrant);
            if (teacher) {
                // If we haven't seen this teacher before, initialize their entry
                if (!acc[teacher]) {
                    acc[teacher] = {
                        key: teacher,
                        teacherName: teacher,
                        soloCount: 0,
                        ensembleCount: 0,
                    };
                }

                // Increment the count based on the performance category
                const perfCategory = (registrant.PerformanceCategory || '').trim().toLowerCase();
                if (perfCategory === 'solo') {
                    acc[teacher].soloCount += 1;
                } else if (perfCategory === 'ensemble') {
                    acc[teacher].ensembleCount += 1;
                }
            }
            return acc;
        }, {});

        // Convert the stats object to an array and sort by teacher name
        const statsArray = Object.values(stats).sort((a, b) => a.teacherName.localeCompare(b.teacherName));

        setTeacherStats(statsArray);
        setIsStatsModalVisible(true);
    };

    const handleExportTeacherStats = () => {
        if (!teacherStats || teacherStats.length === 0) {
            toast.warn("No stats data to export.");
            return;
        }

        toast.info("Preparing teacher stats Excel file...");

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Teacher Registration Stats");

        // Define the headers for your table
        worksheet.getRow(1).values = ['Teacher Name', 'Solo Registrations', 'Ensemble Registrations'];
        worksheet.getRow(1).font = { bold: true };

        // Add the data from your teacherStats array
        teacherStats.forEach(stat => {
            worksheet.addRow([
                stat.teacherName,
                stat.soloCount,
                stat.ensembleCount
            ]);
        });

        // Auto-fit columns
        worksheet.columns.forEach(column => {
            let maxLength = 0;
            column.eachCell({ includeEmpty: true }, cell => {
                const columnLength = cell.value ? cell.value.toString().length : 10;
                if (columnLength > maxLength) {
                    maxLength = columnLength;
                }
            });
            column.width = maxLength < 15 ? 15 : maxLength + 2;
        });

        // Generate and download the file
        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            FileSaver.saveAs(blob, "Teacher_Stats_2025.xlsx");
        });
    };

    const statsColumns = [
        { title: 'Teacher Name', dataIndex: 'teacherName', key: 'teacherName', sorter: (a, b) => a.teacherName.localeCompare(b.teacherName) },
        { title: 'Solo Registrations', dataIndex: 'soloCount', key: 'soloCount', sorter: (a, b) => a.soloCount - b.soloCount },
        { title: 'Ensemble Registrations', dataIndex: 'ensembleCount', key: 'ensembleCount', sorter: (a, b) => a.ensembleCount - b.ensembleCount },
    ];

    const handleDeleteRegistrant = async (recordId) => {
        setDeletingId(recordId);
        try {
            // 1. Create a reference to the document to be deleted
            const docRef = doc(db, 'Registrants2025', recordId);

            // 2. Call Firestore's deleteDoc function
            await deleteDoc(docRef);

            toast.success('Registrant deleted successfully!');

            // 3. Refresh the table data. It's often best to go back to page 1.
            if (page !== 1) setPage(1);
            fetchUserData(1);

        } catch (error) {
            console.error("Error deleting registrant: ", error);
            toast.error('Failed to delete registrant.');
        } finally {
            setDeletingId(null); // Clear the loading state
        }
    };

    // 1. ADD THESE HELPER FUNCTIONS
    // This function takes an S3 URI like "s3://bucket/key..." and returns just the object key.
    const getS3KeyFromUri = (uri) => {
        if (!uri) return '';
        // This splits the string by slashes and takes everything after the 3rd slash.
        return uri.split('/').slice(3).join('/');
    };

    // This function takes an object key and constructs the full public HTTPS URL.
    const constructS3PublicUrl = (s3Key) => {
        const BUCKET_NAME = 'registrants2025';
        // Make sure this is your bucket's actual region
        const BUCKET_REGION = 'ap-southeast-1';
        return `https://${BUCKET_NAME}.s3.${BUCKET_REGION}.amazonaws.com/${s3Key}`;
    };

    function formatDuration(totalSeconds) {
        // Handle non-numeric or negative inputs gracefully
        if (isNaN(totalSeconds) || totalSeconds < 0) {
            return "00:00";
        }

        // 1. Calculate the minutes by dividing by 60 and taking the integer part
        const minutes = Math.floor(totalSeconds / 60);

        // 2. Calculate the remaining seconds using modulo and REMOVE decimals using Math.floor
        const seconds = Math.floor(totalSeconds % 60);

        // 3. Pad both numbers with a leading zero if they are less than 10
        const paddedMinutes = String(minutes).padStart(2, '0');
        const paddedSeconds = String(seconds).padStart(2, '0');

        // 4. Combine them into the final format
        return `${paddedMinutes}:${paddedSeconds}`;
    }

    const handleExportToExcel = () => {
        if (!allData || allData.length === 0) {
            toast.warn("No data available to export.");
            return;
        }

        toast.info("Grouping data and preparing your multi-sheet Excel file...");

        // --- 1. GROUP ALL DATA BY COMPETITION CATEGORY ---
        const groupedByCategory = allData.reduce((acc, registrant) => {
            const category = registrant.competitionCategory || 'Uncategorized';
            if (!acc[category]) {
                acc[category] = [];
            }
            acc[category].push(registrant);
            return acc;
        }, {});

        // --- Duplicate detection logic ---
        const linkCounts = allData.reduce((acc, registrant) => {
            const link = registrant.youtubeLink;
            if (link) {
                acc[link] = (acc[link] || 0) + 1;
            }
            return acc;
        }, {});

        const duplicateTags = {};
        let duplicateCounter = 1;
        for (const link in linkCounts) {
            if (linkCounts[link] > 1) {
                duplicateTags[link] = `duplicate${duplicateCounter}`;
                duplicateCounter++;
            }
        }

        const workbook = new ExcelJS.Workbook();

        // --- 2. LOOP THROUGH EACH CATEGORY AND CREATE A SHEET FOR IT ---
        for (const category in groupedByCategory) {
            // Remove characters that are invalid in Excel worksheet names (* ? : \ / [ ])
            const safeCategory = category.replace(/[*?:\\/\[\]]/g, '').trim();
            const worksheet = workbook.addWorksheet(safeCategory.substring(0, 30));
            const categoryData = groupedByCategory[category];

            // --- 3. PROCESS AND MAP DATA FOR THE CURRENT SHEET ---
            const dataForSheet = [];
            categoryData.forEach(registrant => {
                const originalRowNumber = allData.findIndex(item => item.id === registrant.id) + 1;

                // ✨ MAP AGE CATEGORY TO FULL DESCRIPTION
                const ageCategoryLabel = getAgeCategoryLabel(
                    registrant.ageCategory,
                    registrant.competitionCategory,
                    registrant.PerformanceCategory
                );

                // Get the shared data that's the same for all performers in this registration
                const sharedData = {
                    'Parent/Teacher Name': registrant.name,
                    'Teacher Name': registrant.teacherName,
                    'Remark': registrant.remark,
                    'Competition Category': registrant.competitionCategory,
                    'Instrument Category': registrant.instrumentCategory,
                    'Age Category': ageCategoryLabel, // ✨ USE MAPPED LABEL
                    'Performance Category': registrant.PerformanceCategory,
                    'YouTube Link': registrant.youtubeLink,
                    'Duplicate Link Tag': duplicateTags[registrant.youtubeLink] || '',
                    'Video Duration': formatDuration(registrant.videoDuration),
                    'Repertoire PDF': registrant.pdfRepertoireS3Link,
                    'Birth Certificate': registrant.birthCertS3Link,
                    'Payment Proof': registrant.paymentProofS3Link,
                    'Exam Certificate': registrant.examCertificateS3Link,
                    'Profile Photo': registrant.profilePhotoS3Link,
                    'Registration Date': registrant.createdAt ? new Date(registrant.createdAt.seconds * 1000).toLocaleString('en-GB') : '',
                    'Payment Status': registrant.paymentStatus,
                    'Average Score': registrant?.averageScore || 0,
                    'Final Award': registrant?.finalAward || '-',
                };

                // Check if the registration is for an Ensemble
                if ((registrant.PerformanceCategory || '').trim().toLowerCase() === 'ensemble') {
                    const combinedNames = registrant.performers
                        .map(p => p.fullName || `${p.firstName} ${p.lastName}`)
                        .join(' & ');
                    const combinedEmails = registrant.performers.map(p => p.email).join(', ');
                    const combinedDOBs = registrant.performers.map(p => p.dob).join(', ');
                    const combinedPhones = registrant.performers.map(p => p.phoneNumber).join(', ');

                    dataForSheet.push({
                        'No.': originalRowNumber,
                        'Name': combinedNames,
                        'Email': registrant.performers[0]?.email,
                        'Date of Birth': combinedDOBs,
                        'Phone Number': combinedPhones,
                        'Country': registrant.performers[0]?.country,
                        'City': registrant.performers[0]?.city,
                        ...sharedData
                    });
                } else {
                    // Solo - separate row for each performer
                    registrant.performers.forEach(performer => {
                        dataForSheet.push({
                            'No.': originalRowNumber,
                            'Name': performer.fullName ? `${performer.fullName}` : `${performer.firstName} ${performer.lastName}`,
                            'Email': performer.email,
                            'Date of Birth': performer.dob,
                            'Phone Number': performer.phoneNumber,
                            'Country': performer.country,
                            'City': performer.city,
                            ...sharedData
                        });
                    });
                }
            });

            // --- 4. POPULATE THE CURRENT WORKSHEET ---
            if (dataForSheet.length > 0) {
                const headers = Object.keys(dataForSheet[0]);
                worksheet.getRow(1).values = headers;
                worksheet.getRow(1).font = { bold: true };

                const formatLinkCell = (cell) => {
                    const link = cell.value;
                    if (typeof link !== 'string' || !link) return;

                    let hyperlinkUrl = '';

                    if (link.startsWith('s3://')) {
                        hyperlinkUrl = constructS3PublicUrl(getS3KeyFromUri(link));
                    } else if (link.startsWith('http')) {
                        hyperlinkUrl = link;
                    }

                    if (hyperlinkUrl) {
                        cell.value = {
                            text: 'View Link',
                            hyperlink: hyperlinkUrl,
                        };
                        cell.font = { color: { argb: 'FF0000FF' }, underline: true };
                    }
                };

                const linkColumns = [
                    'Repertoire PDF',
                    'Birth Certificate',
                    'Exam Certificate',
                    'Profile Photo',
                    'Payment Proof',
                ];

                dataForSheet.forEach(item => {
                    const row = worksheet.addRow(Object.values(item));

                    linkColumns.forEach(columnName => {
                        const columnIndex = headers.indexOf(columnName) + 1;
                        if (columnIndex > 0) {
                            formatLinkCell(row.getCell(columnIndex));
                        }
                    });
                });

                worksheet.columns.forEach(column => {
                    let maxLength = 0;
                    column.eachCell({ includeEmpty: true }, cell => {
                        let columnLength = cell.value ? cell.value.toString().length : 10;
                        if (columnLength > maxLength) {
                            maxLength = columnLength;
                        }
                    });
                    column.width = maxLength < 10 ? 10 : maxLength + 2;
                });
            }
        }

        // --- 5. GENERATE AND DOWNLOAD THE FINAL WORKBOOK ---
        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            FileSaver.saveAs(blob, "All_Registrants_by_Category_2025.xlsx");
        });
    };

    const handleExportByCategoryWithAgeTabsRaw = (allData, competitionCategory) => {
        if (!allData || allData.length === 0) {
            toast.warn("No data available to export.");
            return;
        }

        if (!competitionCategory) {
            toast.error("Please specify a competition category.");
            return;
        }

        // Filter data by competition category
        const categoryData = allData.filter(
            registrant => registrant.competitionCategory === competitionCategory
        );

        if (categoryData.length === 0) {
            toast.warn(`No registrants found for ${competitionCategory}.`);
            return;
        }

        toast.info(`Preparing Excel export for ${competitionCategory}...`);

        console.log(categoryData);
        // --- GROUP BY AGE CATEGORY ---
        const groupedByAge = categoryData.reduce((acc, registrant) => {
            // Get age category label
            const ageCategoryLabel = getAgeCategoryLabel(
                registrant.ageCategory,
                registrant.competitionCategory,
                registrant.PerformanceCategory
            );

            // Use "Ensemble" as a separate category if needed
            const categoryKey = (registrant.PerformanceCategory || '').trim().toLowerCase() === 'ensemble'
                ? 'Ensemble'
                : ageCategoryLabel;

            if (!acc[categoryKey]) {
                acc[categoryKey] = [];
            }
            acc[categoryKey].push(registrant);
            return acc;
        }, {});

        // --- Duplicate detection logic ---
        const linkCounts = categoryData.reduce((acc, registrant) => {
            const link = registrant.youtubeLink;
            if (link) {
                acc[link] = (acc[link] || 0) + 1;
            }
            return acc;
        }, {});

        const duplicateTags = {};
        let duplicateCounter = 1;
        for (const link in linkCounts) {
            if (linkCounts[link] > 1) {
                duplicateTags[link] = `duplicate${duplicateCounter}`;
                duplicateCounter++;
            }
        }

        const workbook = new ExcelJS.Workbook();

        // Sort age categories (optional: custom sort order)
        const sortedAgeCategories = Object.keys(groupedByAge).sort((a, b) => {
            // Put Ensemble at the end
            if (a === 'Ensemble') return 1;
            if (b === 'Ensemble') return -1;
            return a.localeCompare(b);
        });

        // --- CREATE A SHEET FOR EACH AGE CATEGORY ---
        sortedAgeCategories.forEach(ageCategory => {
            const ageCategoryData = groupedByAge[ageCategory];

            // Sheet name (max 31 characters, no invalid chars)
            const safeAgeCategory = ageCategory.replace(/[*?:\\/\[\]]/g, '').trim();
            const sheetName = safeAgeCategory.length > 30
                ? safeAgeCategory.substring(0, 30)
                : safeAgeCategory;

            const worksheet = workbook.addWorksheet(sheetName);

            // --- PROCESS DATA FOR THIS AGE CATEGORY ---
            const dataForSheet = [];

            ageCategoryData.forEach((registrant, index) => {
                // Get age category label
                const ageCategoryLabel = getAgeCategoryLabel(
                    registrant.ageCategory,
                    registrant.competitionCategory,
                    registrant.PerformanceCategory
                );

                // Shared data for all performers
                const sharedData = {
                    'Parent/Teacher Name': registrant.name || '-',
                    'Teacher Name': registrant.teacherName || '-',
                    'Remark': registrant.remark || '-',
                    'Competition Category': registrant.competitionCategory,
                    'Instrument Category': registrant.instrumentCategory,
                    'Age Category': ageCategoryLabel,
                    'Performance Category': registrant.PerformanceCategory,
                    'YouTube Link': registrant.youtubeLink || '-',
                    'Duplicate Link Tag': duplicateTags[registrant.youtubeLink] || '',
                    'Video Duration': formatDuration(registrant.videoDuration),
                    'Repertoire PDF': registrant.pdfRepertoireS3Link || '-',
                    'Birth Certificate': registrant.birthCertS3Link || '-',
                    'Payment Proof': registrant.paymentProofS3Link || '-',
                    'Exam Certificate': registrant.examCertificateS3Link || '-',
                    'Profile Photo': registrant.profilePhotoS3Link || '-',
                    'Registration Date': registrant.createdAt
                        ? new Date(registrant.createdAt.seconds * 1000).toLocaleString('en-GB')
                        : '-',
                    'Payment Status': registrant.paymentStatus || 'PENDING',
                    'Average Score': registrant?.averageScore || 0,
                    'Final Award': registrant?.finalAward || '-',
                };

                // Check if Ensemble
                if ((registrant.PerformanceCategory || '').trim().toLowerCase() === 'ensemble') {
                    const combinedNames = registrant.performers
                        .map(p => p.fullName || `${p.firstName} ${p.lastName}`)
                        .join(' & ');
                    const combinedEmails = registrant.performers.map(p => p.email).join(', ');
                    const combinedDOBs = registrant.performers.map(p => p.dob).join(', ');
                    const combinedPhones = registrant.performers.map(p => p.phoneNumber).join(', ');

                    dataForSheet.push({
                        'No.': index + 1,
                        'Name': combinedNames,
                        'Email': registrant.performers[0]?.email || '-',
                        'Date of Birth': combinedDOBs,
                        'Phone Number': combinedPhones,
                        'Country': registrant.performers[0]?.country || '-',
                        'City': registrant.performers[0]?.city || '-',
                        ...sharedData
                    });
                } else {
                    // Solo - separate row for each performer (though usually just 1)
                    registrant.performers.forEach(performer => {
                        dataForSheet.push({
                            'No.': index + 1,
                            'Name': performer.fullName
                                ? performer.fullName
                                : `${performer.firstName} ${performer.lastName}`,
                            'Email': performer.email || '-',
                            'Date of Birth': performer.dob || '-',
                            'Phone Number': performer.phoneNumber || '-',
                            'Country': performer.country || '-',
                            'City': performer.city || '-',
                            ...sharedData
                        });
                    });
                }
            });

            // --- POPULATE WORKSHEET ---
            if (dataForSheet.length > 0) {
                const headers = Object.keys(dataForSheet[0]);

                // Add header row
                worksheet.getRow(1).values = headers;
                worksheet.getRow(1).font = { bold: true, color: { argb: 'FFFFFFFF' } };
                worksheet.getRow(1).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FF4472C4' }
                };
                worksheet.getRow(1).alignment = { vertical: 'middle', horizontal: 'center' };

                // Format link cells
                const formatLinkCell = (cell) => {
                    const link = cell.value;
                    if (typeof link !== 'string' || !link || link === '-') return;

                    let hyperlinkUrl = '';

                    if (link.startsWith('s3://')) {
                        hyperlinkUrl = constructS3PublicUrl(getS3KeyFromUri(link));
                    } else if (link.startsWith('http')) {
                        hyperlinkUrl = link;
                    }

                    if (hyperlinkUrl) {
                        cell.value = {
                            text: 'View Link',
                            hyperlink: hyperlinkUrl,
                        };
                        cell.font = { color: { argb: 'FF0000FF' }, underline: true };
                    }
                };

                const linkColumns = [
                    'Repertoire PDF',
                    'Birth Certificate',
                    'Exam Certificate',
                    'Profile Photo',
                    'Payment Proof',
                    'YouTube Link'
                ];

                // Add data rows
                dataForSheet.forEach(item => {
                    const row = worksheet.addRow(Object.values(item));

                    // Format link columns
                    linkColumns.forEach(columnName => {
                        const columnIndex = headers.indexOf(columnName) + 1;
                        if (columnIndex > 0) {
                            formatLinkCell(row.getCell(columnIndex));
                        }
                    });

                    // Alternate row colors for better readability
                    if (row.number % 2 === 0) {
                        row.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: 'FFF2F2F2' }
                        };
                    }
                });

                // Auto-fit columns
                worksheet.columns.forEach(column => {
                    let maxLength = 0;
                    column.eachCell({ includeEmpty: true }, cell => {
                        let columnLength = cell.value ? cell.value.toString().length : 10;
                        if (columnLength > maxLength) {
                            maxLength = columnLength;
                        }
                    });
                    column.width = maxLength < 10 ? 10 : Math.min(maxLength + 2, 50);
                });

                // Freeze first row
                worksheet.views = [
                    { state: 'frozen', xSplit: 0, ySplit: 1 }
                ];
            }
        });

        // --- GENERATE AND DOWNLOAD ---
        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const fileName = `${competitionCategory}_Registrants_by_Age_2025.xlsx`;
            FileSaver.saveAs(blob, fileName);
            toast.success(`Excel file for ${competitionCategory} exported successfully!`);
        }).catch(error => {
            console.error('Export error:', error);
            toast.error('Failed to export Excel file');
        });
    };

    const handleExportByCategoryWithAgeTabs = (allData, competitionCategory) => {
        if (!allData || allData.length === 0) {
            toast.warn("No data available to export.");
            return;
        }

        if (!competitionCategory) {
            toast.error("Please specify a competition category.");
            return;
        }

        // Filter data by competition category
        const categoryData = allData.filter(
            registrant => registrant.competitionCategory === competitionCategory
        );

        if (categoryData.length === 0) {
            toast.warn(`No registrants found for ${competitionCategory}.`);
            return;
        }

        toast.info(`Preparing Excel export for ${competitionCategory}...`);

        // TODO: this is hacky stupid way because we missed to upload the file type for harp on december 2025
        // when first time update to upload the file directly to out s3 bucket
        // --- NEW: MODIFY DATA FOR REGISTRANTS BETWEEN NOV 23 AND DEC 14, 2025 ---
        const startDate = new Date('2025-11-23T00:00:00');
        // Set end date to end of day to include all registrations on the 14th
        const endDate = new Date('2025-12-14T23:59:59');

        const processedData = categoryData.map(registrant => {
            // Create a shallow copy so we don't mutate the original state
            const r = { ...registrant };

            // 1. Safely parse the creation date
            let regDate = null;
            if (r.createdAt?.seconds) {
                regDate = new Date(r.createdAt.seconds * 1000);
            } else if (r.createdAt) {
                regDate = new Date(r.createdAt);
            }

            // 2. Check Range: (Start Date <= regDate <= End Date)
            if (regDate && regDate >= startDate && regDate <= endDate && r.pdfRepertoireS3Link) {
                // 3. Remove .pdf extension (case insensitive)
                r.pdfRepertoireS3Link = r.pdfRepertoireS3Link.replace(/\.pdf$/i, "");
            }

            return r;
        });

        // --- GROUP BY AGE CATEGORY ---
        const groupedByAge = processedData.reduce((acc, registrant) => {
            // Get age category label
            const ageCategoryLabel = getAgeCategoryLabel(
                registrant.ageCategory,
                registrant.competitionCategory,
                registrant.PerformanceCategory
            );

            // Use "Ensemble" as a separate category if needed
            const categoryKey = (registrant.PerformanceCategory || '').trim().toLowerCase() === 'ensemble'
                ? 'Ensemble'
                : ageCategoryLabel;

            if (!acc[categoryKey]) {
                acc[categoryKey] = [];
            }
            acc[categoryKey].push(registrant);
            return acc;
        }, {});

        const workbook = new ExcelJS.Workbook();

        // Sort age categories (optional: custom sort order)
        const sortedAgeCategories = Object.keys(groupedByAge).sort((a, b) => {
            // Put Ensemble at the end
            if (a === 'Ensemble') return 1;
            if (b === 'Ensemble') return -1;
            return a.localeCompare(b);
        });

        // --- CREATE A SHEET FOR EACH AGE CATEGORY ---
        sortedAgeCategories.forEach(ageCategory => {
            const ageCategoryData = groupedByAge[ageCategory];

            // Sheet name (max 31 characters, no invalid chars)
            const safeAgeCategory = ageCategory.replace(/[*?:\\/\[\]]/g, '').trim();
            const sheetName = safeAgeCategory.length > 30
                ? safeAgeCategory.substring(0, 30)
                : safeAgeCategory;

            const worksheet = workbook.addWorksheet(sheetName);

            // --- PROCESS DATA FOR THIS AGE CATEGORY ---
            const dataForSheet = [];

            ageCategoryData.forEach((registrant, index) => {
                const ageCategoryLabel = getAgeCategoryLabel(
                    registrant.ageCategory,
                    registrant.competitionCategory,
                    registrant.PerformanceCategory
                );
                // Check if Ensemble
                if ((registrant.PerformanceCategory || '').trim().toLowerCase() === 'ensemble') {
                    const combinedNames = registrant.performers
                        .map(p => p.fullName || `${p.firstName} ${p.lastName}`)
                        .join(' & ');

                    dataForSheet.push({
                        'No.': index + 1,
                        'Name': combinedNames,
                        'Instrument Category': registrant.instrumentCategory || '-',
                        // 'birthCert': registrant.birthCertS3Link || '-',
                        'Repertoire PDF': registrant.pdfRepertoireS3Link || '-',
                        'Video Performance': registrant.videoPerformanceS3Link || '-',
                        'Duration': formatDuration(registrant.videoDuration),
                        'Teacher Name': registrant.teacherName || '-',
                    });
                } else {
                    // Solo - separate row for each performer (though usually just 1)
                    registrant.performers.forEach(performer => {
                        dataForSheet.push({
                            'No.': index + 1,
                            'Name': performer.fullName
                                ? performer.fullName
                                : `${performer.firstName} ${performer.lastName}`,
                            // 'birthCert': registrant.birthCertS3Link || '-',
                            'Instrument Category': registrant.instrumentCategory || '-',
                            'Repertoire PDF': registrant.pdfRepertoireS3Link || '-',
                            'Video Performance': registrant.videoPerformanceS3Link || '-',
                            'Duration': formatDuration(registrant.videoDuration),
                            'Teacher Name': registrant.teacherName || '-',
                        });
                    });
                }
            });

            // --- POPULATE WORKSHEET ---
            if (dataForSheet.length > 0) {
                const headers = Object.keys(dataForSheet[0]);

                // Add header row
                worksheet.getRow(1).values = headers;
                worksheet.getRow(1).font = { bold: true, color: { argb: 'FFFFFFFF' } };
                worksheet.getRow(1).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FF4472C4' }
                };
                worksheet.getRow(1).alignment = { vertical: 'middle', horizontal: 'center' };

                // Format link cells
                const formatLinkCell = (cell) => {
                    const link = cell.value;
                    if (typeof link !== 'string' || !link || link === '-') return;

                    let hyperlinkUrl = '';

                    if (link.startsWith('s3://')) {
                        hyperlinkUrl = constructS3PublicUrl(getS3KeyFromUri(link));
                    } else if (link.startsWith('http')) {
                        hyperlinkUrl = link;
                    }

                    if (hyperlinkUrl) {
                        cell.value = {
                            text: 'View Link',
                            hyperlink: hyperlinkUrl,
                        };
                        cell.font = { color: { argb: 'FF0000FF' }, underline: true };
                    }
                };

                const linkColumns = [
                    // 'birthCert',
                    'Repertoire PDF',
                    'Video Performance'
                ];

                // Add data rows
                dataForSheet.forEach(item => {
                    const row = worksheet.addRow(Object.values(item));

                    // Format link columns
                    linkColumns.forEach(columnName => {
                        const columnIndex = headers.indexOf(columnName) + 1;
                        if (columnIndex > 0) {
                            formatLinkCell(row.getCell(columnIndex));
                        }
                    });

                    // Alternate row colors for better readability
                    if (row.number % 2 === 0) {
                        row.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: 'FFF2F2F2' }
                        };
                    }
                });

                // Auto-fit columns
                worksheet.columns.forEach(column => {
                    let maxLength = 0;
                    column.eachCell({ includeEmpty: true }, cell => {
                        let columnLength = cell.value ? cell.value.toString().length : 10;
                        if (columnLength > maxLength) {
                            maxLength = columnLength;
                        }
                    });
                    column.width = maxLength < 10 ? 10 : Math.min(maxLength + 2, 50);
                });

                // Freeze first row
                worksheet.views = [
                    { state: 'frozen', xSplit: 0, ySplit: 1 }
                ];
            }
        });

        // --- GENERATE AND DOWNLOAD ---
        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const fileName = `${competitionCategory}_Registrants_by_Age_2025.xlsx`;
            FileSaver.saveAs(blob, fileName);
            toast.success(`Excel file for ${competitionCategory} exported successfully!`);
        }).catch(error => {
            console.error('Export error:', error);
            toast.error('Failed to export Excel file');
        });
    };

    const handleExportJuryComments = async (exportCat, eventId) => {
        let exportData = allData;

        if (eventId) {
            exportData = exportData.filter(registrant => registrant.eventId === eventId);
        }

        if (exportCat) {
            exportData = exportData.filter(registrant => registrant.competitionCategory === exportCat);
            if (exportData.length === 0) {
                toast.warn(`No registrants found for ${exportCat} in the selected Event ID.`);
                return;
            }
        }

        if (!exportData || exportData.length === 0) {
            toast.warn("No data available to export.");
            return;
        }

        toast.info(exportCat
            ? `Fetching jury scores and preparing Excel export for ${exportCat}... Please wait.`
            : "Fetching jury scores and preparing Excel export for ALL categories... Please wait.");

        try {
            // OPTIMIZATION: Fetch all scores AT ONCE rather than querying per registrant or category.
            // This is 1 read operation per document instead of thousands of individual queries, preventing cost spikes.
            const scoresSnapshot = await getDocs(collection(db, "JuryScores2025"));
            const allScoresMap = {};
            scoresSnapshot.docs.forEach(doc => {
                const data = doc.data();
                if (data.isFinalized === false) return;
                const regId = data.registrantId;
                if (!allScoresMap[regId]) allScoresMap[regId] = [];

                let jName = data.juryName || "Unknown";
                // Dedup if this regId already has a score from this same jName
                let counter = 1;
                while (allScoresMap[regId].some(s => s.juryName === jName)) {
                    counter++;
                    jName = `${data.juryName || "Unknown"} ${counter}`;
                }

                allScoresMap[regId].push({
                    juryName: jName,
                    score: Number(data.score) || 0,
                    comment: data.comment || "-"
                });
            });

            const zip = new JSZip();

            // 1. Group by Competition Category
            const groupedByCompetition = exportData.reduce((acc, registrant) => {
                const compCat = registrant.competitionCategory || 'Uncategorized';
                if (!acc[compCat]) acc[compCat] = [];
                acc[compCat].push(registrant);
                return acc;
            }, {});

            for (const compCat in groupedByCompetition) {
                const compData = groupedByCompetition[compCat];

                // 2. Group by Age Category (using getAgeCategoryLabel)
                const groupedByAge = compData.reduce((acc, registrant) => {
                    const ageCategoryLabel = getAgeCategoryLabel(
                        registrant.ageCategory,
                        registrant.competitionCategory,
                        registrant.PerformanceCategory
                    );
                    const categoryKey = (registrant.PerformanceCategory || '').trim().toLowerCase() === 'ensemble'
                        ? 'Ensemble'
                        : ageCategoryLabel;

                    if (!acc[categoryKey]) acc[categoryKey] = [];
                    acc[categoryKey].push(registrant);
                    return acc;
                }, {});

                // 3. For each age category, create a workbook
                for (const ageCat in groupedByAge) {
                    const ageData = groupedByAge[ageCat];

                    // Double check ageData actually has length
                    if (!ageData || ageData.length === 0) continue;

                    const workbook = new ExcelJS.Workbook();
                    const sheetName = (ageCat.replace(/[*?:\\/[\]]/g, '').trim() || 'Sheet1').substring(0, 30);
                    const worksheet = workbook.addWorksheet(sheetName);

                    // Collect all unique jury names in this specific age group
                    const allJuryNames = new Set();
                    ageData.forEach(reg => {
                        const scores = allScoresMap[reg.id] || [];
                        scores.forEach(s => {
                            if (s.juryName) {
                                allJuryNames.add(s.juryName);
                            }
                        });
                    });
                    const sortedJuries = Array.from(allJuryNames).sort();

                    const dataForSheet = [];

                    ageData.forEach((registrant, index) => {
                        // Shared data
                        const scores = allScoresMap[registrant.id] || [];
                        const juryDataMap = {};
                        scores.forEach(s => {
                            if (s.juryName) {
                                juryDataMap[s.juryName] = s;
                            }
                        });

                        const baseData = {
                            'No.': index + 1,
                            'Average Score': registrant?.averageScore || 0,
                            'Final Award': registrant?.finalAward || '-',
                        };

                        const enrichWithJuryData = (item) => {
                            sortedJuries.forEach(jury => {
                                const jd = juryDataMap[jury];
                                item[`${jury} Score`] = jd ? jd.score : '-';
                                item[`${jury} Comment`] = jd ? (jd.comment || '-') : '-';
                            });
                            return item;
                        };

                        if ((registrant.PerformanceCategory || '').trim().toLowerCase() === 'ensemble') {
                            const combinedNames = registrant.performers && Array.isArray(registrant.performers)
                                ? registrant.performers.map(p => p.fullName || `${p.firstName} ${p.lastName}`).join(' & ')
                                : registrant.name;

                            let item = { 'No.': baseData['No.'], 'Name': combinedNames, ...baseData };
                            item = enrichWithJuryData(item);
                            dataForSheet.push(item);
                        } else {
                            if (registrant.performers && Array.isArray(registrant.performers) && registrant.performers.length > 0) {
                                registrant.performers.forEach(performer => {
                                    let item = {
                                        'No.': baseData['No.'],
                                        'Name': performer.fullName ? performer.fullName : `${performer.firstName} ${performer.lastName}`,
                                        ...baseData
                                    };
                                    item = enrichWithJuryData(item);
                                    dataForSheet.push(item);
                                });
                            } else {
                                let item = { 'No.': baseData['No.'], 'Name': registrant.name || '-', ...baseData };
                                item = enrichWithJuryData(item);
                                dataForSheet.push(item);
                            }
                        }
                    });

                    if (dataForSheet.length > 0) {
                        const headers = [
                            'No.', 'Name',
                            ...sortedJuries.flatMap(j => [`${j} Score`, `${j} Comment`]),
                            'Average Score', 'Final Award'
                        ];

                        worksheet.getRow(1).values = headers;
                        worksheet.getRow(1).font = { bold: true };

                        dataForSheet.forEach(item => {
                            const rowData = headers.map(h => item[h]);
                            worksheet.addRow(rowData);
                        });

                        worksheet.columns.forEach(column => {
                            let maxLength = 0;
                            column.eachCell({ includeEmpty: true }, cell => {
                                let columnLength = cell.value ? cell.value.toString().length : 10;
                                if (columnLength > maxLength) {
                                    maxLength = columnLength;
                                }
                            });
                            column.width = maxLength < 10 ? 10 : Math.min(maxLength + 2, 50);
                        });

                        const buffer = await workbook.xlsx.writeBuffer();
                        const safeCompCat = compCat.replace(/[*?:\\/[\]]/g, '').trim() || 'Uncategorized';
                        const safeAgeCat = ageCat.replace(/[*?:\\/[\]]/g, '').trim() || 'Unknown';
                        zip.file(`${safeCompCat}/${safeCompCat}_${safeAgeCat}_Comments.xlsx`, buffer);
                    }
                }
            }

            zip.generateAsync({ type: "blob" }).then(function (content) {
                saveAs(content, "Jury_Comments_Export.zip");
                toast.success("Successfully exported all jury comments!");
            });

        } catch (error) {
            console.error("Error exporting jury comments:", error);
            toast.error("Failed to export jury comments. Check console.");
        }
    };

    const handleDownloadPDF = async (record) => {
        toast.info('Preparing your download...');
        try {
            const filesToDownload = [];
            const performerName = record.performers[0]?.fullName ? `${record.performers[0]?.fullName}` : `${record.performers[0]?.firstName}_${record.performers[0]?.lastName}`;

            const addFilesFromField = (fieldContent, baseName) => {
                if (typeof fieldContent === 'string' && fieldContent) {
                    const links = fieldContent.split('&').map(link => link.trim());
                    links.forEach((link, index) => {
                        const fileName = links.length > 1 ? `${baseName}_${index + 1}.pdf` : `${baseName}.pdf`;
                        if (link.startsWith('http') || link.startsWith('s3://')) {
                            // Just send the raw link to the backend
                            filesToDownload.push({
                                link: link,
                                zipPath: fileName
                            });
                        }
                    });
                }
            };

            // Process all link fields
            addFilesFromField(record.birthCertS3Link, 'birth_certificate');
            addFilesFromField(record.examCertificateS3Link, 'exam_certificate');
            addFilesFromField(record.paymentProofS3Link, 'payment_proof');
            addFilesFromField(record.pdfRepertoireS3Link, 'repertoire');
            addFilesFromField(record.profilePhotoS3Link, 'profile_photo');

            // TODO: might need to remove this becuase all of the newest file already have
            // extension file pdf.
            // const modifiedFiles = filesToDownload.map(file => {
            //     return {
            //         ...file, // Keep other properties like zipPath
            //         // Replace '.pdf' with an empty string, but only if it's at the end of the string ($)
            //         link: file.link.replace(/\.pdf$/, "")
            //     };
            // });

            // if (modifiedFiles.length === 0) {
            //     message.warn({ content: "No documents are linked for this registrant.", key: 'download' });
            //     return;
            // }

            // Call the backend API (no change here)
            const response = await apis.aws.downloadFiles(filesToDownload, {
                responseType: 'blob'
            });

            const blob = new Blob([response.data], { type: 'application/zip' });
            saveAs(blob, `${performerName}_documents.zip`);
            toast.success('Download started!');

        } catch (error) {
            console.error('Download failed:', error);
            toast.error('Failed to download documents.');
        }
    };

    const updatePaymentStatus = async (record) => {
        try {
            const docRef = doc(db, 'Registrants2025', record.id);
            await updateDoc(docRef, {
                paymentStatus: "PAID"
            });
            toast.success(`Successfully updated registrant(s)!`);
            fetchUserData(1)
        } catch (error) {
            console.error("Error updating document(s): ", error);
        }
    };

    // --- NEW HANDLER FUNCTIONS FOR THE MODAL ---
    const showEditModal = (record) => {
        setEditingRecord(record);
        // Populate the form state from the selected record
        setEditFormState({
            firstName: record.performers[0]?.firstName || '',
            lastName: record.performers[0]?.lastName || '',
            fullName: record.performers[0]?.fullName || '',
            youtubeLink: record.youtubeLink || '',
            email: record.performers[0]?.email || '',
            ageCategory: record.ageCategory || '',

        });
        setIsEditModalVisible(true);
    };

    const handleEditCancel = () => {
        setIsEditModalVisible(false);
        setEditingRecord(null);
        setEditFormState({ firstName: '', lastName: '', youtubeLink: '', email: '' });
    };

    // A single handler for all input changes in the modal
    const handleEditFormChange = (e) => {
        const { name, value } = e.target;
        setEditFormState(prev => ({ ...prev, [name]: value }));
    };

    const handleEditSave = async () => {
        if (!editingRecord) return;

        setIsSaving(true);
        try {
            // Firestore requires us to update the entire 'performers' array.
            // 1. Make a copy of the original performers array.
            const updatedPerformers = [...editingRecord.performers];

            // 2. Update the name for the first performer in our copy.
            updatedPerformers[0] = {
                ...updatedPerformers[0],
                firstName: editFormState.firstName,
                lastName: editFormState.lastName,
                fullName: editFormState.fullName,
                email: editFormState.email,

            };

            // 3. Prepare the final payload with the new youtubeLink and the modified performers array.
            const updatePayload = {
                youtubeLink: editFormState.youtubeLink,
                ageCategory: editFormState.ageCategory,
                performers: updatedPerformers,
            };

            const docRef = doc(db, 'Registrants2025', editingRecord.id);
            await updateDoc(docRef, updatePayload);

            toast.success('Registrant data updated successfully!');
            fetchUserData(page);
            handleEditCancel();

        } catch (error) {
            console.error("Error updating registrant data: ", error);
            toast.error('Failed to update data.');
        } finally {
            setIsSaving(false);
        }
    };

    const handleViewVideo = async (record) => {
        let urlToPlay = null;

        try {
            const s3Link = record.videoPerformanceS3Link;
            const response = await apis.aws.getPublicVideoLinkAws({ s3Link });
            urlToPlay = response.data.url;
        } catch (error) {
            console.error("Failed to load video", error);
            toast.error("Could not load video file.");
            return;
        }

        if (urlToPlay) {
            setVideoUrl(urlToPlay);
            setIsVideoModalOpen(true);
        }
    };

    const handleUploadRegistrantAPCS2025 = (e) => {
        e.preventDefault();
        const file = e.target.files[0];
        if (!file) return;

        setIsUploading(true);
        toast.info('Reading and processing your file...');

        const reader = new FileReader();
        reader.onload = async (event) => {
            try {
                const data = event.target.result;
                const workbook = xlsx.read(data, { type: "array", cellDates: true });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];

                // --- CORRECTED PARSING LOGIC ---
                // 1. Parse the entire sheet into an array of arrays to get full control.
                const rowsAsArrays = xlsx.utils.sheet_to_json(worksheet, { header: 1 });
                // const rowsAsArrays = rowsAsArraysRaw.slice(1);

                // 3. Manually extract the header row (row 2) and the data rows (row 4 onwards).
                const headers = rowsAsArrays[0];
                const dataRows = rowsAsArrays.slice(1); // Skips banner, header, and example row.

                // 4. Manually convert the arrays into an array of objects using the headers.
                const json = dataRows.map(rowArray => {
                    const rowObject = {};
                    headers.forEach((header, index) => {
                        if (header) { // Only add data for columns that have a header
                            rowObject[header] = rowArray[index];
                        }
                    });
                    return rowObject;
                });
                // --- END OF CORRECTED PARSING LOGIC ---


                if (json.length === 0) {
                    toast.error('The uploaded file has no data to process.');
                    setIsUploading(false);
                    return;
                }

                toast.info(`Processing ${json.length} records...`);

                // Helper to parse strings like "1,5 mins" or "3 mins" into seconds
                const parseDurationToSeconds = (durationStr) => {
                    if (typeof durationStr !== 'string' || !durationStr) return 0;
                    try {
                        const cleanedStr = durationStr.replace(',', '.').replace('mins', '').trim();
                        const minutes = parseFloat(cleanedStr);
                        return Math.round(minutes * 60);
                    } catch (e) {
                        return 0;
                    }
                };

                // Helper to split a full name into first and last names
                const splitFullName = (fullName) => {
                    if (typeof fullName !== 'string' || !fullName) return { firstName: '', lastName: '' };
                    const parts = fullName.trim().split(' ');
                    const lastName = parts.pop();
                    const firstName = parts.join(' ');
                    return { firstName, lastName };
                };

                const registrantsToUpload = json.map(row => {
                    const fullNameString = row['Full Name'] || '';
                    const dobString = String(row['Date of Birth'] || '');
                    const phoneString = String(row['Phone Number'] || '');

                    // 1. Split each field by its respective separator into an array
                    const individualNames = fullNameString.split('&').map(name => name.trim());
                    const individualDobs = dobString.split('&').map(dob => dob.trim());
                    const individualPhones = phoneString.split('/').map(phone => phone.trim());

                    const performers = individualNames.map((name, index) => {
                        const { firstName, lastName } = splitFullName(name);

                        // This creates a complete performer object for each person
                        return {
                            firstName: firstName,
                            lastName: lastName,
                            fullName: name,
                            email: row['Email'] || '',
                            dob: parseDateString(individualDobs[index] || individualDobs[0] || ''),
                            gender: row['Gender'] || '',
                            nationality: row['Nationality'] || 'Indonesia',
                            country: row['Country'] || 'Indonesia',
                            province: row['Province'] || '',
                            city: row['City'] || '',
                            zipCode: String(row['Zip Code'] || ''),
                            addressLine: row['addressline'] || '',
                            phoneNumber: individualPhones[index] || individualPhones[0] || '',
                            countryCode: row['Country Code'] || '+62',
                        };
                    });

                    return {
                        // Top-level Info (assuming these might not be in the sheet)
                        name: row['Parent/Guardian Name'] || '',
                        userType: row['User Type'] || 'Teacher',
                        teacherName: row['Teacher Name'] || '',

                        // Competition Details from the sheet
                        competitionCategory: row['Competition Category'] || 'Piano', // Example default
                        instrumentCategory: row['Instrument Category'] || '',
                        ageCategory: (row['Age Category'] || ''),
                        PerformanceCategory: row['Performance Category'] || 'Solo',

                        // Links from the file
                        youtubeLink: row['YouTube Link'] || '',
                        pdfRepertoireS3Link: row['Repertoire'] || '',
                        profilePhotoS3Link: row['Photo'] || '', // Assuming a 'Photo' column might exist
                        birthCertS3Link: row['Birth Certificate'] || '',
                        examCertificateS3Link: row['Recommendation Letter / Exam Certificate'] || '',

                        // Nested Performer Data
                        performers: performers,

                        // Default / Generated Values
                        totalPerformer: performers.length, // Correctly count the number of performers
                        agreement: true,
                        paymentStatus: 'PAID',
                        videoDuration: parseDurationToSeconds(row['Max Duration']),
                        createdAt: serverTimestamp(),
                    };
                });

                console.log("registrantsToUpload", registrantsToUpload)

                // Batch Upload Step
                message.loading({ content: `Uploading ${registrantsToUpload.length} documents to Firestore...`, key: 'upload' });
                const batchSize = 499;
                for (let i = 0; i < registrantsToUpload.length; i += batchSize) {
                    const batch = writeBatch(db);
                    const chunk = registrantsToUpload.slice(i, i + batchSize);

                    // chunk.forEach((registrantData) => {
                    //     const newDocRef = doc(collection(db, "Registrants2025Dummy"));
                    //     batch.set(newDocRef, registrantData);
                    // });

                    await batch.commit();
                }

                // --- NEW: INTELLIGENTLY GROUP EMAILS BEFORE SENDING ---
                const groupedEmails = json.reduce((acc, row) => {
                    const email = (row['Email'] || '').toLowerCase().trim();
                    const name = (row['Full Name'] || '').trim();

                    // Skip rows that don't have an email or a name
                    if (!email || !name) return acc;

                    if (!acc[email]) {
                        // If we see this email for the first time, create a new entry
                        acc[email] = {
                            email: row['Email'],
                            teacherName: row['Teacher Name'] || 'Participant',
                            // Use the original 'Full Name' which can be "John Doe" or "John Doe & Jane Smith"
                            names: [name]
                        };
                    } else {
                        // If this email already exists, just add the new name to its list
                        acc[email].names.push(name);
                    }
                    return acc;
                }, {});

                console.log("groupedEmails", groupedEmails)

                // Convert the grouped object back into an array for the API
                const emailPayload = Object.values(groupedEmails);

                // --- Send the consolidated email payload to the backend ---
                if (emailPayload.length > 0) {
                    await apis.email.sendEmailNotifyBulkUpdateRegistrant(emailPayload);
                }

                message.success({ content: `Successfully uploaded ${registrantsToUpload.length} registrants!`, key: 'upload' });
                fetchUserData(1);

            } catch (error) {
                console.error("Error processing or uploading file:", error);
                message.error({ content: 'An error occurred. Please check the console for details.', key: 'upload' });
            } finally {
                setIsUploading(false);
                e.target.value = null;
            }
        };
        reader.readAsArrayBuffer(file);
    };

    console.log("registrantDatas", registrantDatas)

    // --- BATCH VIDEO DURATION SYNC STATE ---
    const [isSyncModalOpen, setIsSyncModalOpen] = useState(false);
    const [syncProgress, setSyncProgress] = useState(0);
    const [syncLogs, setSyncLogs] = useState([]); // To show what's happening
    const [isSyncing, setIsSyncing] = useState(false);
    const stopSyncRef = useRef(false); // To cancel the process if needed

    // Helper: Get duration from a playable URL (Hidden Video Element)
    const fetchDurationFromUrl = (url) => {
        return new Promise((resolve, reject) => {
            const video = document.createElement('video');
            video.src = url;
            video.preload = 'metadata';
            video.muted = true;

            // Timeout after 15 seconds to prevent hanging
            const timeout = setTimeout(() => {
                video.remove();
                resolve(0); // Return 0 on timeout
            }, 15000);

            video.onloadedmetadata = () => {
                clearTimeout(timeout);
                const duration = video.duration;
                video.remove();
                resolve(duration);
            };

            video.onerror = () => {
                clearTimeout(timeout);
                video.remove();
                resolve(0); // Return 0 on error
            };
        });
    };

    // 4. Upload Certificates / Comments (NEW)
    const handleOpenUploadModal = (record) => {
        setUploadingRecord(record);
        setUploadFileList([]);
        setIsUploadModalOpen(true);
    };

    const handleUploadFiles = async () => {
        if (uploadFileList.length === 0) {
            message.warning("Please select files to upload.");
            return;
        }
        setIsUploadingCert(true);
        try {
            // Determine folder path: Use existing examCert path OR create new one
            let folderPath = '';
            if (uploadingRecord.examCertificateS3Link) {
                // Extract folder from s3 link: s3://bucket/folder/file.pdf
                const parts = uploadingRecord.examCertificateS3Link.split('/');
                // parts[3] is usually the folder name in your structure
                folderPath = parts[3];
            } else {
                // Fallback generation
                const baseName = uploadingRecord.name.replace(/\s/g, "");
                const timestamp = new Date().toISOString().replace(/[-:.TZ]/g, "").slice(0, 14);
                folderPath = `${baseName}_${timestamp}`;
            }

            const updates = {};

            for (const file of uploadFileList) {
                // Determine file type based on name or user selection (simplifying to name check here)
                const isCommentSheet = file.name.toLowerCase().includes('comment');
                const isCertificate = file.name.toLowerCase().includes('certificate');

                // Get Signed URL
                const res = await apis.aws.postSignedUrl(folderPath, file.name, file.type);
                const signedUrl = res.data.link;

                // Upload to S3
                await axios.put(signedUrl, file, {
                    headers: {
                        'Content-Type': file.type,
                    },
                });

                const s3Link = `s3://registrants2025/${folderPath}/${file.name}`;

                if (isCommentSheet) updates.commentSheetS3Link = s3Link;
                if (isCertificate) updates.certificateS3Link = s3Link;
                // Fallback: append to generic array if you have one, or just update arbitrary fields
            }

            console.log("uploadingRecord.id", uploadingRecord.id)
            // Update Firestore
            const docRef = doc(db, 'Registrants2025', uploadingRecord.id);
            await updateDoc(docRef, updates);

            message.success("Files uploaded successfully!");
            setIsUploadModalOpen(false);
            fetchUserData(page);

        } catch (error) {
            console.error("Upload failed", error);
            message.error("Failed to upload files.");
        } finally {
            setIsUploadingCert(false);
        }
    };

    useEffect(() => {
        const fetchRelevantScores = async () => {
            // 1. If no registrants on this page, do nothing
            if (!registrantDatas || registrantDatas.length === 0) return;

            try {
                // 2. Extract the IDs of the 10 people on screen
                const visibleIds = registrantDatas.map(r => r.id);

                // 3. Query scores ONLY for these IDs
                // Note: Firestore 'in' operator supports up to 10-30 items, perfectly safe for page size 10
                const scoresQuery = query(
                    collection(db, "JuryScores2025"),
                    where("registrantId", "in", visibleIds)
                );

                const querySnapshot = await getDocs(scoresQuery);

                // 4. Map them exactly as before
                const mapping = {};
                querySnapshot.forEach((doc) => {
                    const data = doc.data();
                    const regId = data.registrantId;
                    if (!mapping[regId]) mapping[regId] = [];
                    mapping[regId].push({
                        juryName: data.juryName || "Unknown",
                        score: Number(data.score) || 0,
                        comment: data.comment
                    });
                });

                // 5. Update state (merging with existing cache if you want, or just setting fresh)
                setScoresMap(mapping);

            } catch (error) {
                console.error("Error fetching specific scores:", error);
            }
        };

        fetchRelevantScores();
    }, [registrantDatas]);

    // --- HELPER TO CALCULATE AVERAGE ---
    const getScoreData = (registrantId) => {
        const scores = scoresMap[registrantId] || [];
        if (scores.length === 0) return { avg: '-', details: [] };

        const total = scores.reduce((sum, item) => sum + item.score, 0);
        const avg = (total / scores.length).toFixed(2); // Keep 2 decimal places

        return { avg, details: scores };
    };

    const handleSyncScores = async () => {
        setIsScoreSyncing(true);
        message.loading({ content: "Calculating awards and syncing to database...", key: 'scoreSync' });

        try {
            // 1. Fetch ALL Registrants
            // Note: For production with thousands of docs, you might need pagination or cloud function.
            // For < 2000 docs, client-side batching is okay.
            const registrantsSnapshot = await getDocs(collection(db, "Registrants2025"));

            // 2. Fetch ALL Scores
            const scoresSnapshot = await getDocs(collection(db, "JuryScores2025"));

            // 3. Map Scores by Registrant ID
            const scoresMap = {};
            scoresSnapshot.docs.forEach(doc => {
                const data = doc.data();
                const regId = data.registrantId;
                if (!scoresMap[regId]) scoresMap[regId] = [];
                scoresMap[regId].push(Number(data.score) || 0);
            });

            // 4. Prepare Batch Updates
            let batch = writeBatch(db);
            let operationCount = 0;
            let updatedCount = 0;

            registrantsSnapshot.docs.forEach((docSnap) => {
                const regId = docSnap.id;
                const scores = scoresMap[regId] || [];

                let finalAward = "N/A";
                let averageScore = 0;

                if (scores.length > 0) {
                    const total = scores.reduce((a, b) => a + b, 0);
                    // Use standard rounding to match your Excel logic if needed, 
                    // or simple division. Your render logic used .toFixed(2) for display.
                    averageScore = parseFloat((total / scores.length).toFixed(2));
                    finalAward = calculateAward(averageScore);
                }

                // Check if update is needed (optimization)
                const currentData = docSnap.data();
                if (currentData.finalAward !== finalAward || currentData.averageScore !== averageScore) {
                    batch.update(docSnap.ref, {
                        finalAward: finalAward,
                        averageScore: averageScore
                    });
                    operationCount++;
                    updatedCount++;
                }

                // Commit batch every 500 operations
                if (operationCount === 499) {
                    batch.commit();
                    batch = writeBatch(db);
                    operationCount = 0;
                }
            });

            // Commit remaining
            if (operationCount > 0) {
                await batch.commit();
            }

            message.success({ content: `Successfully synced awards for ${updatedCount} registrants!`, key: 'scoreSync' });
            fetchUserData(page); // Refresh table

        } catch (error) {
            console.error("Score sync failed:", error);
            message.error({ content: "Failed to sync scores.", key: 'scoreSync' });
        } finally {
            setIsScoreSyncing(false);
        }
    };

    // --- CSV SCORE IMPORT HANDLER ---
    const handleImportScores = (e) => {
        e.preventDefault();
        const file = e.target.files[0];
        if (!file) return;

        setIsImportingScores(true);
        message.loading({ content: 'Reading CSV and matching registrants...', key: 'importScores' });

        const reader = new FileReader();
        reader.onload = async (event) => {
            try {
                const data = event.target.result;
                const workbook = xlsx.read(data, { type: 'array' });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const csvRows = xlsx.utils.sheet_to_json(worksheet);

                if (csvRows.length === 0) {
                    toast.error({ content: 'The CSV file has no data.', key: 'importScores' });
                    setIsImportingScores(false);
                    return;
                }

                // Determine the competition category from the first row
                const csvCategory = (csvRows[0]['CATEGORY'] || '').trim();

                // Fetch registrants matching this category
                let registrantsData = [];
                if (csvCategory) {
                    const registrantsQuery = query(
                        collection(db, 'Registrants2025'),
                        where('competitionCategory', '==', csvCategory.charAt(0).toUpperCase() + csvCategory.slice(1).toLowerCase())
                    );
                    const registrantsSnap = await getDocs(registrantsQuery);
                    registrantsData = registrantsSnap.docs.map(d => ({ id: d.id, ...d.data() }));
                } else {
                    // Fallback: fetch all registrants
                    const registrantsSnap = await getDocs(collection(db, 'Registrants2025'));
                    registrantsData = registrantsSnap.docs.map(d => ({ id: d.id, ...d.data() }));
                }

                // --- Name Normalization Helper ---
                const normalizeName = (name) => (name || '').toUpperCase().replace(/\s+/g, ' ').trim();

                message.loading({ content: `Matching ${csvRows.length} CSV rows against ${registrantsData.length} registrants...`, key: 'importScores' });

                // Build a lookup: name -> registrant
                const nameToRegistrant = {};

                // 1. Index Ensemble combined names (e.g., "John Doe & Jane Smith")
                registrantsData.forEach(reg => {
                    if (reg.performers && reg.performers.length > 1) {
                        const combinedName = reg.performers
                            .map(p => normalizeName(p.fullName || `${p.firstName || ''} ${p.lastName || ''}`))
                            .join(' & ');
                        if (combinedName) nameToRegistrant[combinedName] = reg;
                    }
                });

                // 2. Index individuals in Ensembles as fallbacks
                registrantsData.filter(r => r.performers?.length > 1).forEach(reg => {
                    reg.performers.forEach(p => {
                        const name = normalizeName(p.fullName || `${p.firstName || ''} ${p.lastName || ''}`);
                        if (name && !nameToRegistrant[name]) {
                            nameToRegistrant[name] = reg;
                        }
                    });
                });

                // 3. Index Solo performers (PRIORITY)
                // If a name exists in both solo and ensemble, solo will overwrite/take priority here.
                registrantsData.filter(r => r.performers?.length === 1).forEach(reg => {
                    const p = reg.performers[0];
                    const name = normalizeName(p.fullName || `${p.firstName || ''} ${p.lastName || ''}`);
                    if (name) {
                        nameToRegistrant[name] = reg;
                    }
                });

                const matched = [];
                const unmatched = [];

                // Match CSV rows to registrants
                csvRows.forEach(row => {
                    const csvName = normalizeName(row['NAME']);
                    const csvScore = parseFloat(row['FINAL SCORE']);
                    const csvAward = (row['AWARD'] || '').trim();

                    if (!csvName) return;

                    const registrant = nameToRegistrant[csvName];
                    if (registrant && !isNaN(csvScore)) {
                        matched.push({
                            csvName,
                            csvScore,
                            csvAward,
                            registrantId: registrant.id,
                            registrant,
                        });
                    } else {
                        unmatched.push({ csvName, csvScore: isNaN(csvScore) ? 'N/A' : csvScore, csvAward });
                    }
                });

                // Write matched scores to JuryScores2025 using batched writes
                if (matched.length > 0) {
                    const batchSize = 499;
                    for (let i = 0; i < matched.length; i += batchSize) {
                        const batch = writeBatch(db);
                        const chunk = matched.slice(i, i + batchSize);

                        chunk.forEach(({ registrantId, csvScore, registrant }) => {
                            const docId = `${registrantId}_system`;
                            const registrantName = registrant.performers?.length > 1
                                ? registrant.performers.map(p => p.fullName || `${p.firstName || ''} ${p.lastName || ''}`.trim()).join(' & ')
                                : (registrant.performers?.[0]?.fullName || `${registrant.performers?.[0]?.firstName || ''} ${registrant.performers?.[0]?.lastName || ''}`.trim());

                            batch.set(doc(db, 'JuryScores2025', docId), {
                                registrantId,
                                juryUserId: 'system',
                                juryName: 'System',
                                juryEmail: 'system@apcs.com',
                                score: csvScore,
                                comment: 'Please kindly ask our admin for the comments',
                                competitionCategory: registrant.competitionCategory || '',
                                ageCategory: registrant.ageCategory || '',
                                performanceCategory: registrant.PerformanceCategory || '',
                                registrantName: registrantName,
                                timestamp: serverTimestamp(),
                                isFinalized: true,
                            });
                        });

                        await batch.commit();
                    }
                }

                setImportScoreResults({ matched, unmatched });
                setIsImportScoreModalOpen(true);
                toast.success({ content: `Import complete! ${matched.length} matched, ${unmatched.length} unmatched.`, key: 'importScores', duration: 5 });

            } catch (error) {
                console.error('CSV import error:', error);
                toast.error({ content: `Import failed: ${error.message}`, key: 'importScores' });
            } finally {
                setIsImportingScores(false);
                e.target.value = null; // Reset file input
            }
        };
        reader.readAsArrayBuffer(file);
    };

    const columns = getRegistrants2025Columns(getScoreData, getAgeCategoryLabel, handleDownloadPDF, updatePaymentStatus, showEditModal, handleDeleteRegistrant, deletingId, handleViewVideo, handleOpenUploadModal);

    return (
        <Content
            style={{
                margin: '0 16px',
            }}
        >
            <Space style={{ marginBottom: 16 }} wrap>
                <div>
                    Total Data: {totalDocs}
                </div>
                <Input.Search
                    placeholder="Search by performer name..."
                    onSearch={value => { setPage(1); setSearchTerm(value); }}
                    style={{ width: 300 }}
                    allowClear
                />
                <Input.Search
                    placeholder="Search by teacher name..."
                    onSearch={value => { setPage(1); setSearchTeacherName(value); }}
                    style={{ width: 300 }}
                    allowClear
                />
                <Select
                    placeholder="Filter by Competition"
                    style={{ width: 200 }}
                    onChange={handleCompetitionFilterChange}
                    options={competitionCategoryOptions}
                    allowClear
                />
                <Select
                    placeholder="Filter by Age Category"
                    style={{ width: 200 }}
                    onChange={handleAgeFilterChange}
                    options={ageCategoryOptions}
                    allowClear
                />
                <Select
                    placeholder="Filter by Performance"
                    style={{ width: 200 }}
                    onChange={handlePerformanceFilterChange}
                    options={performanceCategoryOptions}
                    allowClear
                />
                <Select
                    placeholder="Filter by Event ID"
                    style={{ width: 200 }}
                    onChange={(value) => { setPage(1); setEventIdFilter(value); }}
                    options={[
                        { value: 'APCS2025', label: 'APCS2025' },
                        { value: 'APCS2026', label: 'APCS2026' },
                    ]}
                    allowClear
                />
            </Space>
            <div
                style={{
                    padding: 24,
                    minHeight: 360,
                    background: colorBgContainer,
                    borderRadius: borderRadiusLG,
                    overflow: 'auto',
                }}
            >
                <Table columns={columns} dataSource={registrantDatas} onChange={handlePageChange} pagination={false} />
                <Pagination
                    className='mt-16'
                    current={page}
                    pageSize={pageSize}
                    total={totalDocs} // Total number of items
                    onChange={handlePageChange}
                    showSizeChanger={false}
                // onShowSizeChange={onShowSizeChange}
                />
            </div>
            <form style={{ background: "white" }}>
                <label htmlFor="Save Registrand to DB" >Upload Registrant To Database </label>
                <input
                    type="file"
                    name="upload"
                    id="upload"
                    onChange={handleUploadRegistrantAPCS2025}
                    style={{ marginLeft: 4 }}
                />
            </form>
            <div
                style={{
                    padding: 24,
                    minHeight: 360,
                    background: colorBgContainer,
                    borderRadius: borderRadiusLG,
                }}
            >
                <div style={{ marginBottom: 16 }}>
                    <Select
                        style={{ width: 250, marginRight: 8 }}
                        placeholder="Select Category for Export"
                        value={exportCategory}
                        onChange={setExportCategory}
                        options={competitionCategoryOptions}
                        allowClear
                    />
                    <Button type="primary" onClick={handleExportToExcel}>Export All to excel</Button>
                    <Button type="primary" style={{ marginLeft: 8 }} onClick={() => handleExportByCategoryWithAgeTabsRaw(allData, exportCategory)}>Export to excel Age Raw</Button>
                    <Button type="primary" style={{ marginLeft: 8 }} onClick={() => handleExportByCategoryWithAgeTabs(allData, exportCategory)}>Export to excel Age for jury sheet</Button>
                    <Button type="primary" style={{ marginLeft: 8, backgroundColor: '#52c41a', borderColor: '#52c41a' }} onClick={() => handleExportJuryComments(exportCategory, eventIdFilter)}>Export Jury Comments (ZIP)</Button>
                </div>
                {/* --- EMAIL MANAGEMENT SECTION --- */}
                <Card
                    title={<Typography.Title level={4} style={{ margin: 0 }}>Email Management</Typography.Title>}
                    style={{
                        marginTop: 24,
                        marginBottom: 24,
                        borderRadius: borderRadiusLG,
                        boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                    }}
                >
                    <Space direction="vertical" size="large" style={{ width: '100%' }}>
                        {/* 1. General Announcement */}
                        <div style={{ paddingBottom: 16, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography.Text strong block style={{ marginBottom: 8 }}>General Announcement Email</Typography.Text>
                            <Space wrap>
                                <DatePicker.RangePicker
                                    value={emailDateRange}
                                    onChange={(dates) => setEmailDateRange(dates)}
                                    placeholder={['Start Date', 'End Date']}
                                />
                                <Button
                                    type="primary"
                                    danger
                                    icon={<CloudUploadOutlined />}
                                    loading={isSendingEmails}
                                    onClick={handleSendEmailAnnouncement}
                                >
                                    Send Announcement (to specific date range or ALL)
                                </Button>
                                <Button
                                    icon={<SendOutlined />}
                                    onClick={() => handleSendTestEmail('announcement')}
                                    title="Send test announcement to my email"
                                >
                                    Send Test
                                </Button>
                            </Space>
                        </div>

                        {/* 2. Specific Feature Emails */}
                        <div style={{ paddingBottom: 16, borderBottom: '1px solid #f0f0f0' }}>
                            <Typography.Text strong block style={{ marginBottom: 8 }}>Event Specific Updates</Typography.Text>
                            <Space wrap size="middle">
                                {/* Reschedule Email */}
                                <Space>
                                    <Button
                                        type="primary"
                                        style={{ backgroundColor: '#722ed1', borderColor: '#722ed1' }}
                                        onClick={() => setIsRescheduleModalVisible(true)}
                                    >
                                        Send Reschedule Stage Email
                                    </Button>
                                    <Button
                                        icon={<SendOutlined />}
                                        onClick={() => handleSendTestEmail('reschedule')}
                                        title="Send test reschedule email to my email"
                                    >
                                        Send Test
                                    </Button>
                                </Space>

                                {/* Gala Concert Update */}
                                <Space>
                                    <Select
                                        style={{ width: 250 }}
                                        placeholder="Select Category for Gala Update"
                                        value={galaUpdateCategory}
                                        onChange={setGalaUpdateCategory}
                                        options={competitionCategoryOptions}
                                        allowClear
                                    />
                                    <Button
                                        type="primary"
                                        style={{ backgroundColor: '#faad14', borderColor: '#faad14', color: 'white' }}
                                        loading={isSendingGalaUpdate}
                                        onClick={handleSendGalaConcertUpdateEmail}
                                    >
                                        Send Gala Concert Update (Winners Only)
                                    </Button>
                                    <Button
                                        icon={<SendOutlined />}
                                        onClick={() => handleSendTestEmail('gala_update')}
                                        title="Send test gala update to my email"
                                    >
                                        Send Test
                                    </Button>
                                </Space>
                            </Space>
                        </div>

                        <Typography.Text type="secondary">
                            * Email functions will filter recipients based on the selected parameters. Please double-check before sending.
                        </Typography.Text>
                    </Space>
                </Card>

                <Button onClick={handleShowStatsModal}>
                    View Teacher Stats
                </Button>
                <Button
                    icon={<CalculatorOutlined />}
                    onClick={handleSyncScores}
                    loading={isScoreSyncing}
                    style={{ marginLeft: 8 }}
                >
                    Sync Awards
                </Button>
                <input
                    type="file"
                    ref={importScoreFileRef}
                    accept=".csv,.xlsx,.xls"
                    style={{ display: 'none' }}
                    onChange={handleImportScores}
                />
                <Button
                    icon={<ImportOutlined />}
                    onClick={() => importScoreFileRef.current?.click()}
                    loading={isImportingScores}
                    style={{ marginLeft: 8 }}
                >
                    Import Scores CSV
                </Button>
                {/* <Button
                    type="primary"
                    loading={isMigratingEventId}
                    style={{ marginLeft: 8, backgroundColor: '#13c2c2', borderColor: '#13c2c2' }}
                    onClick={async () => {
                        const confirmed = window.confirm(
                            'This will add eventId="APCS2025" to ALL documents in Registrants2025. Proceed?'
                        );
                        if (!confirmed) return;
                        setIsMigratingEventId(true);
                        try {
                            const res = await apis.registrant.migrateEventId({
                                eventId: 'APCS2025',
                                collectionName: 'Registrants2025',
                            });
                            message.success(res.data?.message || 'Migration complete!');
                            fetchUserData();
                        } catch (err) {
                            console.error(err);
                            message.error('Migration failed. Check console.');
                        } finally {
                            setIsMigratingEventId(false);
                        }
                    }}
                >
                    Migrate Event ID (APCS2025)
                </Button> */}
            </div>
            <Modal
                title="Updating Video Durations"
                open={isUpdating}
                footer={null}
                closable={false}
            >
                <p>{updateMessage}</p>
                <Progress percent={progress} />
                <p style={{ marginTop: '10px', textAlign: 'center' }}>Please keep this tab open until the process is complete.</p>
            </Modal>
            <Modal
                title="Edit Registrant Details"
                open={isEditModalVisible}
                onOk={handleEditSave}
                onCancel={handleEditCancel}
                confirmLoading={isSaving}
                okText="Save"
            >
                {editingRecord && (
                    <Form layout="vertical">
                        <Form.Item label="Performer First Name">
                            <Input
                                name="firstName"
                                value={editFormState.firstName}
                                onChange={handleEditFormChange}
                            />
                        </Form.Item>
                        <Form.Item label="Performer Last Name">
                            <Input
                                name="lastName"
                                value={editFormState.lastName}
                                onChange={handleEditFormChange}
                            />
                        </Form.Item>
                        <Form.Item label="Performer Last Name">
                            <Input
                                name="fullName"
                                value={editFormState.fullName}
                                onChange={handleEditFormChange}
                            />
                        </Form.Item>
                        <Form.Item label="Email">
                            <Input
                                name="email"
                                value={editFormState.email}
                                onChange={handleEditFormChange}
                            />
                        </Form.Item>
                        <Form.Item label="YouTube Link">
                            <Input
                                name="youtubeLink"
                                value={editFormState.youtubeLink}
                                onChange={handleEditFormChange}
                                placeholder="https://youtube.com/..."
                            />
                        </Form.Item>
                        <Form.Item label="Age Category">
                            <Input
                                name="ageCategory"
                                value={editFormState.ageCategory}
                                onChange={handleEditFormChange}
                                placeholder="Young"
                            />
                        </Form.Item>
                    </Form>
                )}
            </Modal>
            <Modal
                title="Teacher Registration Summary"
                open={isStatsModalVisible}
                onCancel={() => setIsStatsModalVisible(false)}
                footer={[
                    <Button key="close" onClick={() => setIsStatsModalVisible(false)}>
                        Close
                    </Button>,
                    <Button key="export" type="primary" onClick={handleExportTeacherStats}>
                        Export to Excel
                    </Button>
                ]}
                width={800}
            >
                <Table
                    dataSource={teacherStats}
                    columns={statsColumns}
                    pagination={{ pageSize: 10 }}
                />
            </Modal>
            {/* CSV Score Import Results Modal */}
            <Modal
                title={`CSV Score Import Results`}
                open={isImportScoreModalOpen}
                onCancel={() => setIsImportScoreModalOpen(false)}
                footer={[
                    <Button key="close" onClick={() => setIsImportScoreModalOpen(false)}>
                        Close
                    </Button>,
                    <Button
                        key="sync"
                        type="primary"
                        icon={<CalculatorOutlined />}
                        onClick={() => {
                            setIsImportScoreModalOpen(false);
                            handleSyncScores();
                        }}
                    >
                        Sync Awards Now
                    </Button>,
                ]}
                width={700}
            >
                <div style={{ marginBottom: 16 }}>
                    <p><strong style={{ color: '#52c41a' }}>✅ Matched: {importScoreResults.matched.length}</strong></p>
                    {importScoreResults.matched.length > 0 && (
                        <Table
                            size="small"
                            pagination={{ pageSize: 5 }}
                            dataSource={importScoreResults.matched.map((m, i) => ({ ...m, key: i }))}
                            columns={[
                                { title: 'Name', dataIndex: 'csvName', key: 'name' },
                                { title: 'Score', dataIndex: 'csvScore', key: 'score', width: 100 },
                                { title: 'Award', dataIndex: 'csvAward', key: 'award', width: 150 },
                            ]}
                        />
                    )}
                </div>
                {importScoreResults.unmatched.length > 0 && (
                    <div>
                        <p><strong style={{ color: '#ff4d4f' }}>❌ Unmatched: {importScoreResults.unmatched.length}</strong></p>
                        <Table
                            size="small"
                            pagination={{ pageSize: 5 }}
                            dataSource={importScoreResults.unmatched.map((u, i) => ({ ...u, key: i }))}
                            columns={[
                                { title: 'Name (from CSV)', dataIndex: 'csvName', key: 'name' },
                                { title: 'Score', dataIndex: 'csvScore', key: 'score', width: 100 },
                                { title: 'Award', dataIndex: 'csvAward', key: 'award', width: 150 },
                            ]}
                        />
                    </div>
                )}
            </Modal>
            <Modal
                title="Performance Preview"
                open={isVideoModalOpen}
                onCancel={() => {
                    setIsVideoModalOpen(false);
                    setVideoUrl(null); // Stop video when closed
                }}
                footer={[
                    <Button key="close" onClick={() => setIsVideoModalOpen(false)}>Close</Button>
                ]}
                width={800}
                destroyOnClose
            >
                {videoUrl && (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <video
                            src={videoUrl}
                            controls
                            autoPlay
                            preload="metadata" // Only download the "Index" first, not the video
                            style={{ width: '100%', maxHeight: '450px' }}
                        >
                            Your browser does not support the video tag.
                        </video>
                    </div>
                )}
            </Modal>
            <Modal
                title="Syncing Video Durations"
                open={isSyncModalOpen}
                closable={!isSyncing}
                maskClosable={false}
                footer={[
                    <Button
                        key="close"
                        disabled={isSyncing}
                        onClick={() => setIsSyncModalOpen(false)}
                    >
                        Close
                    </Button>
                ]}
                onCancel={() => {
                    if (isSyncing) {
                        // Optional: Logic to stop the loop if you want
                        stopSyncRef.current = true;
                    }
                    setIsSyncModalOpen(false);
                }}
            >
                <div style={{ textAlign: 'center', marginBottom: 20 }}>
                    <Progress
                        type="circle"
                        percent={syncProgress}
                        status={isSyncing ? "active" : "success"}
                        strokeColor="#e5cc92"
                    />
                    <p style={{ marginTop: 10 }}>
                        {isSyncing ? "Processing videos... Please do not close this window." : "Process Complete!"}
                    </p>
                </div>

                {/* Log Window */}
                <div style={{
                    height: '200px',
                    overflowY: 'auto',
                    background: '#f5f5f5',
                    padding: '10px',
                    borderRadius: '4px',
                    border: '1px solid #d9d9d9'
                }}>
                    <List
                        size="small"
                        dataSource={syncLogs}
                        renderItem={(item) => (
                            <List.Item style={{ padding: '4px 0', fontSize: '12px' }}>
                                {item}
                            </List.Item>
                        )}
                    />
                </div>
            </Modal>
            <Modal
                title="Upload Jury Documents"
                open={isUploadModalOpen}
                onCancel={() => setIsUploadModalOpen(false)}
                onOk={handleUploadFiles}
                confirmLoading={isUploadingCert}
                okText="Upload"
            >
                <p>Upload <strong>Certificate</strong> or <strong>Comment Sheet</strong> for {uploadingRecord?.name}.</p>
                <p style={{ fontSize: '12px', color: '#888', marginBottom: '16px' }}>
                    * Please ensure files are named clearly (e.g., "Certificate.pdf" or "CommentSheet.pdf").
                    The system will categorize them based on the filename.
                </p>

                <Upload
                    beforeUpload={() => false} // Prevent auto upload
                    fileList={uploadFileList}
                    onChange={({ fileList }) => setUploadFileList(fileList)}
                    multiple
                    accept=".pdf,.jpg,.jpeg,.png"
                >
                    <Button icon={<CloudUploadOutlined />}>Select Files</Button>
                </Upload>
            </Modal>
            {/* Reschedule Stage Email Modal */}
            <Modal
                title={`Send Reschedule Stage Email (${rescheduleSelectedRowKeys.length} selected)`}
                open={isRescheduleModalVisible}
                onOk={handleSendRescheduleEmail}
                onCancel={() => {
                    setIsRescheduleModalVisible(false);
                    setRescheduleSelectedRowKeys([]);
                    setRescheduleSearchTerm('');
                }}
                confirmLoading={isSendingRescheduleEmails}
                okText={`Send to ${rescheduleSelectedRowKeys.length} Registrant(s)`}
                okButtonProps={{ disabled: rescheduleSelectedRowKeys.length === 0, style: { backgroundColor: '#722ed1', borderColor: '#722ed1' } }}
                width={800}
            >
                <p style={{ marginBottom: 12, color: '#555' }}>
                    Search and select the registrants you want to send the <strong>Performance Stage Reschedule</strong> email to.
                </p>
                <Input.Search
                    placeholder="Search by performer name..."
                    value={rescheduleSearchTerm}
                    onChange={(e) => setRescheduleSearchTerm(e.target.value)}
                    style={{ marginBottom: 16 }}
                    allowClear
                />
                <Table
                    rowSelection={{
                        selectedRowKeys: rescheduleSelectedRowKeys,
                        onChange: (selectedKeys) => setRescheduleSelectedRowKeys(selectedKeys),
                        preserveSelectedRowKeys: true,
                    }}
                    rowKey="id"
                    size="small"
                    pagination={{ pageSize: 8, size: 'small' }}
                    scroll={{ y: 320 }}
                    dataSource={(allData || []).filter(r => {
                        if (!rescheduleSearchTerm) return true;
                        const lower = rescheduleSearchTerm.toLowerCase();
                        // Search across ALL performer names in the list
                        if (r.performers && r.performers.length > 0) {
                            return r.performers.some(performer => {
                                const performerName = (performer.fullName || `${performer.firstName || ''} ${performer.lastName || ''}`).toLowerCase();
                                return performerName.includes(lower);
                            });
                        }
                        // Fallback: search the top-level name field
                        return (r.name || '').toLowerCase().includes(lower);
                    })}
                    columns={[
                        {
                            title: 'Name',
                            key: 'name',
                            render: (_, record) => {
                                if (record.performers && record.performers.length > 0) {
                                    return record.performers
                                        .map(p => p.fullName || `${p.firstName || ''} ${p.lastName || ''}`.trim())
                                        .join(' & ');
                                }
                                return record.name || '-';
                            }
                        },
                        {
                            title: 'Email',
                            key: 'email',
                            render: (_, record) => {
                                if (record.performers && record.performers.length > 0) {
                                    return record.performers[0].email || '-';
                                }
                                return record.email || '-';
                            }
                        },
                        {
                            title: 'Category',
                            dataIndex: 'CompetitionCategory',
                            key: 'category',
                        },
                        {
                            title: 'Award',
                            dataIndex: 'finalAward',
                            key: 'award',
                            render: (award) => award || '-',
                        },
                    ]}
                />
            </Modal>
            {/* Gala Update Selection Modal */}
            <Modal
                title={`Send Gala Concert Update (${galaUpdateSelectedRowKeys.length} selected)`}
                open={isGalaUpdateModalVisible}
                onOk={handleGalaUpdateConfirmSend}
                onCancel={() => {
                    setIsGalaUpdateModalVisible(false);
                    setGalaUpdateRecipients([]);
                    setGalaUpdateSelectedRowKeys([]);
                    setGalaUpdateSearchTerm('');
                    setGalaUpdateCategory(null);
                }}
                confirmLoading={isSendingGalaUpdate}
                okText={`Send to ${galaUpdateSelectedRowKeys.length} Winner(s)`}
                okButtonProps={{
                    disabled: galaUpdateSelectedRowKeys.length === 0,
                    style: { backgroundColor: '#faad14', borderColor: '#faad14', color: 'white' }
                }}
                width={800}
            >
                <p style={{ marginBottom: 12, color: '#555' }}>
                    Review the list of winners for <strong>{galaUpdateCategory}</strong>. You can manually unselect anyone who shouldn't receive this specific update.
                </p>
                <Input.Search
                    placeholder="Search by name or email..."
                    value={galaUpdateSearchTerm}
                    onChange={(e) => setGalaUpdateSearchTerm(e.target.value)}
                    style={{ marginBottom: 16 }}
                    allowClear
                />
                <Table
                    rowSelection={{
                        selectedRowKeys: galaUpdateSelectedRowKeys,
                        onChange: (selectedKeys) => setGalaUpdateSelectedRowKeys(selectedKeys),
                    }}
                    rowKey="id"
                    size="small"
                    pagination={{ pageSize: 8 }}
                    scroll={{ y: 320 }}
                    dataSource={galaUpdateRecipients.filter(r => {
                        if (!galaUpdateSearchTerm) return true;
                        const lower = galaUpdateSearchTerm.toLowerCase();
                        return (r.name || '').toLowerCase().includes(lower) || (r.email || '').toLowerCase().includes(lower);
                    })}
                    columns={[
                        {
                            title: 'Name',
                            dataIndex: 'name',
                            key: 'name',
                            sorter: (a, b) => a.name.localeCompare(b.name),
                        },
                        {
                            title: 'Email',
                            dataIndex: 'email',
                            key: 'email',
                        }
                    ]}
                />
            </Modal>
        </Content>
    )
}

export default RegistrantDashboard;